import { getDeviceInfo } from '@sitebase/device-detector';
import { checkNativeActionSupport } from './lib';

export const nativeShare = async (data: ShareData) => {
  const deviceInfo = getDeviceInfo();

  if (deviceInfo.isNative && deviceInfo.isAndroid) {
    if (!checkNativeActionSupport('shareContent')) {
      throw new Error('Android shareContent is not supported');
    }

    window.ActionWebInterface?.doAction(
      'shareContent',
      JSON.stringify({ title: data.title, text: data.text }),
    );
  } else {
    await navigator.share(data);
  }
};
